import { ArrowRight, Building2, Briefcase, Check, Home } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";

const PLANS = [
  {
    icon: Home,
    title: "Moradias",
    items: ["Visitas semanais, quinzenais ou mensais", "Relva, sebes, canteiros e limpeza", "O mesmo cuidado em cada visita"],
  },
  {
    icon: Building2,
    title: "Condomínios",
    items: ["Proposta clara para a assembleia", "Plano anual com periodicidade definida", "Interlocutor direto com o administrador"],
  },
  {
    icon: Briefcase,
    title: "Empresas",
    items: ["Intervenções discretas e programadas", "Contrato anual com valor fixo", "Registo das intervenções realizadas"],
  },
];

export default function Maintenance() {
  return (
    <section id="manutencao" data-testid="maintenance-section" className="scroll-mt-24 bg-pine-deep py-20 text-ivory sm:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-10">
        <SectionHead
          dark
          overline="Manutenção Regular"
          title="O seu espaço verde sempre tratado, sem precisar de se lembrar"
          text="Com um contrato de manutenção regular, definimos consigo a periodicidade ideal, semanal, quinzenal ou mensal, e apresentamos um valor fixo e transparente. Chegamos, tratamos e deixamos tudo impecável."
        />

        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3">
          {PLANS.map((p, i) => (
            <Reveal key={p.title} delay={0.08 * i}>
              <div
                data-testid={`maintenance-plan-${p.title.toLowerCase()}`}
                className="flex h-full flex-col rounded-3xl border border-pine-line bg-white/[0.04] p-8 transition-colors duration-300 hover:bg-white/[0.07]"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-lime-400/15 text-lime-400">
                  <p.icon size={22} />
                </span>
                <h3 className="mt-6 font-serif text-2xl">{p.title}</h3>
                <ul className="mt-5 flex flex-col gap-3">
                  {p.items.map((item) => (
                    <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-ivory/75">
                      <Check size={16} className="mt-0.5 shrink-0 text-lime-400" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-12 flex flex-wrap items-center gap-5">
            <a
              data-testid="maintenance-quote-button"
              href="#orcamento"
              className="group flex items-center gap-2 rounded-full bg-lime-400 px-8 py-4 text-base font-semibold text-pine-deep transition-colors duration-200 hover:bg-lime-300"
            >
              Pedir proposta de manutenção
              <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
            </a>
            <p className="text-sm text-ivory/60">Visita de avaliação gratuita, sem compromisso.</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
